import Toast from 'mdoc/utils/toast/toast.js'
import 'mdoc/utils/toast/icons.js'

export default Toast;